<template>
  <div class="page-content">
    <div class="content-wrapper">
      <div class="content">
        <div class="mb-4">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="font-weight-semibold">Data Tagging Performance</h4>
            <div class="d-flex align-items-center">
              <date-picker range v-model="dateRange" value-type="YYYY-MM-DD" format="D MMM YYYY" style="width: 200px;"
                :disabled-date="disableBeforeMinDate" :shortcuts="datePickerShortcuts"></date-picker>
              <button class="btn btn-primary ml-2" @click="applyDateRange" :disabled="isLoading || isOverviewLoading"
                style="white-space: nowrap;">
                <i v-if="isLoading || isOverviewLoading" class="icon-spinner2 spinner mr-1"></i>
                Apply
              </button>
            </div>
          </div>
          <h5>Team Member Performance</h5>
        </div>

        <div class="table-container mb-4">
          <div class="pt-3 pb-3 pr-3 pl-2 d-flex justify-content-between align-items-center">
            <span>Team Member Performance ({{ overviewStatusSorted.length.toLocaleString() }})</span>
            <span v-if="overviewLastUpdated" class="text-muted" style="font-size:12px;">
              อัปเดตล่าสุด: {{ overviewLastUpdated }}
            </span>
          </div>
          <div class="table-wrapper">
            <div v-if="isOverviewLoading" class="loading-overlay">
              <i class="icon-spinner2 spinner"></i>
              <span class="loading-text">กำลังโหลดข้อมูล...</span>
            </div>
            <table class="table table-hover table-bordered align-middle mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" rowspan="2">Assignee</th>
                  <th scope="col" rowspan="2">File Status</th>
                  <th scope="col" colspan="2">ASSIGN</th>
                  <th scope="col" colspan="3">STATUS</th>
                </tr>
                <tr>
                  <th scope="col" class="assign">Files</th>
                  <th scope="col" class="assign">Rows</th>
                  <th scope="col" class="status">New</th>
                  <th scope="col" class="status">Read</th>
                  <th scope="col" class="status">Deleted</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="!isOverviewLoading && overviewStatus.length > 0">
                  <template v-for="person in overviewStatusSorted">
                    <tr v-for="(row, idx) in person.statuses" :key="person.assignTo + row.status">
                      <td v-if="idx === 0" :rowspan="person.statuses.length + 1"
                        class="align-middle font-weight-semibold">
                        {{ person.assignTo }}
                      </td>
                      <td>{{ row.status }}</td>
                      <td>{{ (row.fileCount || 0).toLocaleString() }}</td>
                      <td>{{ (row.rowCount || 0).toLocaleString() }}</td>
                      <td>{{ (row.newCount || 0).toLocaleString() }}</td>
                      <td>{{ (row.readCount || 0).toLocaleString() }}</td>
                      <td>{{ (row.deleteCount || 0).toLocaleString() }}</td>
                    </tr>
                    <tr :key="person.assignTo + '-total'" class="font-weight-semibold"
                      style="background-color: #f0f4ff;">
                      <td>Total</td>
                      <td>{{ person.sum.fileCount.toLocaleString() }}</td>
                      <td>{{ person.sum.rowCount.toLocaleString() }}</td>
                      <td>{{ person.sum.newCount.toLocaleString() }} <span class="text-muted small fw-normal">({{
                        person.sum.newPct }}%)</span></td>
                      <td>{{ person.sum.readCount.toLocaleString() }} <span class="text-muted small fw-normal">({{
                        person.sum.readPct }}%)</span></td>
                      <td>{{ person.sum.deleteCount.toLocaleString() }} <span class="text-muted small fw-normal">({{
                        person.sum.deletePct }}%)</span></td>
                    </tr>
                  </template>
                </template>
                <tr v-else-if="!isOverviewLoading">
                  <td colspan="7" class="text-center text-muted py-3">กดปุ่ม "Apply" เพื่อโหลดข้อมูล</td>
                </tr>
                <tr v-else>
                  <td colspan="7" style="height: 80px;"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="table-container" v-if="false">
          <div class="pt-3 pb-3 pr-3 pl-2">Team Member Performance ({{ userPerformanceFormated.length.toLocaleString()
          }})</div>
          <div class="table-wrapper">
            <div v-if="isLoading" class="loading-overlay">
              <i class="icon-spinner2 spinner"></i>
              <span class="loading-text">กำลังโหลดข้อมูล...</span>
            </div>
            <table class="table table-hover table-bordered align-middle mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" rowspan="2" width="15%">Member</th>
                  <th scope="col" colspan="2">ASSIGN</th>
                  <th scope="col" colspan="3">STATUS</th>
                  <th scope="col" colspan="2">PERFORMANCE</th>
                </tr>
                <tr>
                  <th scope="col" class="assign">Files</th>
                  <th scope="col" class="assign">Rows</th>
                  <th scope="col" class="status">New</th>
                  <th scope="col" class="status">Read</th>
                  <th scope="col" class="status">Delete</th>
                  <th scope="col" class="performance">Accuracy</th>
                  <th scope="col" class="performance">Late</th>
                </tr>
              </thead>

              <tbody>
                <template v-if="!isLoading">
                  <tr v-for="userPerformance in userPerformanceFormated" :key="userPerformance.assignTo">
                    <td>{{ userPerformance.assignTo }}</td>
                    <td>{{ userPerformance.fileCount.toLocaleString() }}</td>
                    <td>{{ userPerformance.rowCount.toLocaleString() }}</td>
                    <td>{{ (userPerformance.newCount || 0).toLocaleString() }} ({{ userPerformance.newPercent }}%)</td>
                    <td>{{ (userPerformance.readCount || 0).toLocaleString() }} ({{ userPerformance.readPercent }}%)
                    </td>
                    <td>{{ (userPerformance.deleteCount || 0).toLocaleString() }} ({{ userPerformance.deletePercent }}%)
                    </td>
                    <td>{{ userPerformance.accuracyPercent }}%</td>
                    <td>{{ userPerformance.latePercent }}%</td>
                  </tr>
                  <tr v-if="userPerformanceFormated.length === 0">
                    <td colspan="8" class="text-center text-muted py-4">No Data</td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="8" style="height: 120px;"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import serviceRoutes from '../../service-routes'
const validDate = '2025-05-01'
export default {
  data() {
    return {
      dateRange: [],
      userPerformance: [],
      isLoading: false,
      overviewStatus: [],
      overviewLastUpdated: null,
      isOverviewLoading: false
    }
  },
  computed: {
    datePickerShortcuts() {
      const clampStart = (date) => {
        const min = moment(validDate)
        return (moment(date).isBefore(min) ? min : moment(date)).toDate()
      }
      const today = moment().toDate()
      return [
        { text: 'Today', onClick: () => [today, today] },
        { text: 'Last 7 days', onClick: () => [clampStart(moment().subtract(6, 'days')), today] },
        { text: 'Last 30 days', onClick: () => [clampStart(moment().subtract(29, 'days')), today] },
        { text: 'This month', onClick: () => [clampStart(moment().startOf('month')), today] },
        { text: 'Last month', onClick: () => [clampStart(moment().subtract(1, 'month').startOf('month')), moment().subtract(1, 'month').endOf('month').toDate()] },
        { text: 'Last 3 months', onClick: () => [clampStart(moment().subtract(3, 'months')), today] },
        { text: 'Last 6 months', onClick: () => [clampStart(moment().subtract(6, 'months')), today] },
        { text: 'Last 1 year', onClick: () => [clampStart(moment().subtract(1, 'year')), today] }
      ]
    },
    overviewStatusSorted() {
      const TARGET = ['In progress', 'To review']
      const lrm = (vals, total) => {
        if (!total) return vals.map(() => 0)
        const raws = vals.map(v => (v / total) * 100)
        const floors = raws.map(Math.floor)
        const remainder = 100 - floors.reduce((a, b) => a + b, 0)
        const order = vals.map((_, i) => i).sort((a, b) => (raws[b] % 1) - (raws[a] % 1))
        for (let i = 0; i < remainder; i++) floors[order[i]]++
        return floors
      }
      return [...this.overviewStatus]
        .sort((a, b) => a.assignTo.localeCompare(b.assignTo))
        .map(person => {
          const statuses = [...person.statuses]
            .filter(s => TARGET.includes(s.status))
            .sort((a, b) => TARGET.indexOf(a.status) - TARGET.indexOf(b.status))
          const sum = {
            fileCount: statuses.reduce((acc, s) => acc + (s.fileCount || 0), 0),
            rowCount: statuses.reduce((acc, s) => acc + (s.rowCount || 0), 0),
            newCount: statuses.reduce((acc, s) => acc + (s.newCount || 0), 0),
            readCount: statuses.reduce((acc, s) => acc + (s.readCount || 0), 0),
            deleteCount: statuses.reduce((acc, s) => acc + (s.deleteCount || 0), 0)
          }
          const [newPct, readPct, deletePct] = lrm(
            [sum.newCount, sum.readCount, sum.deleteCount], sum.rowCount
          )
          sum.newPct = newPct
          sum.readPct = readPct
          sum.deletePct = deletePct
          return { ...person, statuses, sum }
        })
    },
    userPerformanceFormated() {
      return this.userPerformance.map(v => {
        let newPercent = 0; let readPercent = 0; let deletePercent = 0
        if (v.rowCount > 0) {
          const raws = [
            ((v.newCount || 0) / v.rowCount) * 100,
            ((v.readCount || 0) / v.rowCount) * 100,
            ((v.deleteCount || 0) / v.rowCount) * 100
          ]
          const floors = raws.map(Math.floor)
          const remainder = 100 - floors.reduce((a, b) => a + b, 0)
          const order = [0, 1, 2].sort((a, b) => (raws[b] % 1) - (raws[a] % 1))
          for (let i = 0; i < remainder; i++) floors[order[i]]++
          ;[newPercent, readPercent, deletePercent] = floors
        }
        return {
          ...v,
          newPercent,
          readPercent,
          deletePercent,
          accuracyPercent: v.rowCount > 0 ? Math.ceil((v.correctCount / v.rowCount) * 100) : 0,
          latePercent: v.fileCount > 0 ? Math.ceil((v.lateCount / v.fileCount) * 100) : 0
        }
      })
    }
  },
  methods: {
    pct(val, total) {
      if (!total) return '-'
      return Math.round(((val || 0) / total) * 100) + '%'
    },
    disableBeforeMinDate(date) {
      return moment(date).isBefore(moment(validDate))
    },
    applyDateRange() {
      this.overviewStatus = []
      this.overviewLastUpdated = null
      this.loadOverview()
    },
    async loadOverview() {
      this.isOverviewLoading = true
      const res = await serviceRoutes.getOverviewStatus(
        moment(this.dateRange[0]).startOf('day').toISOString(),
        moment(this.dateRange[1]).endOf('day').toISOString()
      ).catch(() => null)
      if (res) {
        this.overviewStatus = res.data
        this.overviewLastUpdated = moment().format('D MMM YYYY HH:mm')
      }
      this.isOverviewLoading = false
    },
    async loadData() {
      this.isLoading = true
      const data = await serviceRoutes.getTeamPerformance(moment(this.dateRange[0]).startOf('day').toISOString(), moment(this.dateRange[1]).endOf('day').toISOString()).catch((e) => { })
      if (data) {
        this.userPerformance = data.data
      }
      this.isLoading = false
    }
  },
  mounted() {
  },
  beforeMount() {
    let startDate = moment().add(-1, 'month').format('YYYY-MM-DD')
    let endDate = moment().format('YYYY-MM-DD')
    if (moment(startDate).isBefore(moment(validDate))) {
      startDate = validDate
      endDate = validDate
    }
    this.dateRange = [startDate, endDate]
  }
}
</script>

<style scoped>
.table-container {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #ddd;
}

.table-wrapper {
  position: relative;
}

.loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.75);
  z-index: 10;
}

.loading-text {
  font-size: 14px;
  color: #555;
}

.table-container table thead tr:first-child th:first-child {
  border-top-left-radius: 12px;
}

.table-container table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 12px;
}

.assign {
  background-color: #e9f0fa;
}

.status {
  background-color: #fef9e7;
}

.performance {
  background-color: #eef9f9;
}
</style>

<style>
.mx-datepicker-sidebar {
  width: 130px !important;
}

.mx-datepicker-sidebar+.mx-datepicker-content {
  margin-left: 130px !important;
}
</style>
